export default class CalendarWeek {
  constructor(startDay, endDay, days, events) {
    this.startDay = startDay;
    this.endDay = endDay;
    this.days = days;
    this.events = events;
  }
}
